import "App/lib/Crunch";

const ctx: Worker = self as any;

export default
class CrunchDecodeWorker {

    private _arrayBufferCopy  (src, dst, dstByteOffset, numBytes) {
        let dst32Offset = dstByteOffset / 4,
            tail = (numBytes % 4),
            src32 = new Uint32Array(src.buffer, 0, (numBytes - tail) / 4),
            dst32 = new Uint32Array(dst.buffer);

        for (let i = 0; i < src32.length; i++) {
            dst32[dst32Offset + i] = src32[i];
        }
        for (let i = numBytes - tail; i < numBytes; i++) {
            dst[dstByteOffset + i] = src[i];
        }
    }

    public decodeTexture(aMessage: any) {
        let bytes = new Uint8Array(aMessage.arrayBuffer);
        let srcSize = aMessage.arrayBuffer.byteLength;
        //@ts-ignore
        let src = Module._malloc(srcSize);
        let dstSize;

        //@ts-ignore
        this._arrayBufferCopy(bytes, Module.HEAPU8, src, srcSize);

        //@ts-ignore
        let format = Module._crn_get_dxt_format(src, srcSize);
        //@ts-ignore
        let width = Module._crn_get_width(src, srcSize);
        //@ts-ignore
        let height = Module._crn_get_height(src, srcSize);
        //@ts-ignore
        let levels = Module._crn_get_levels(src, srcSize);
        //@ts-ignore
        dstSize = Module._crn_get_uncompressed_size(src, srcSize, 0);
        let dsts = [];
        //@ts-ignore
        dsts.push(Module._malloc(dstSize));

        let cCRNFmtDXT1 = 0;
        let cCRNFmtDXT3 = 1;
        let cCRNFmtDXT5 = 2;

        let ddsData = {
            mipmaps: [],
            width: width,
            height: height,
            format: format === cCRNFmtDXT1 ? 'dxt1' : format === cCRNFmtDXT3 ? 'dxt3' : 'dxt5',
            hasAlpha: format === cCRNFmtDXT5,
            bpp: 4,
            mipmapCount: levels,
            isCubemap: false
        };

        for (let i = 0; i < levels; ++i) {
            if (i) {
                //@ts-ignore
                dstSize = Module._crn_get_uncompressed_size(src, srcSize, i);
                //@ts-ignore
                dsts.push(Module._malloc(dstSize));
            }

            //@ts-ignore
            Module._crn_decompress(src, srcSize, dsts[i], dstSize, i);

            let mipmap = {
                data: null,
                width: width,
                height: height
            };

            //@ts-ignore
            mipmap.data = new Uint8Array(Module.HEAPU8.buffer.slice(dsts[i], dsts[i] + dstSize));//new Uint8Array(Module.HEAPU8.buffer, dsts[i], dstSize);
            ddsData.mipmaps.push(mipmap);

            width *= 0.5;
            height *= 0.5;

            width = Math.floor(width);
            height = Math.floor(height);
        }

        ctx.postMessage({
            type: 'textureDecoded',
            uid: aMessage.uid,
            requestedLevel: aMessage.requestedLevel,
            tileIndex: aMessage.tileIndex,
            ddsData: ddsData
        });

        //@ts-ignore
        Module._free(src);
        for (let i = 0; i < dsts.length; i++) {
            //@ts-ignore
            Module._free(dsts[i]);
        }
    }

    public acceptMessage(e) {
        let message = e.data;

        switch (message.type) {
            case 'decodeTexture':
                this.decodeTexture(message);
                break;
        }
    }
}

let crunchDecodeWorker = new CrunchDecodeWorker();

self.addEventListener('message', function(e) {
    crunchDecodeWorker.acceptMessage(e);
}, false);
